import Widget from '../../Notifications/Widget';

export default Widget;
